import type { ErrorProcessor } from "@/types/ErrorProcessor";

export function usePaymentMethodsErrorsProcessor(): ErrorProcessor {
  return {
    name: "payment_methods",
    test: () => false,
    execute: () => {},
  };
}
